// extracted by mini-css-extract-plugin
export var alert = "SlipAlert-module--alert--5954d";
export var content = "SlipAlert-module--content--3f846";
export var danger = "SlipAlert-module--danger--b4311";
export var icon = "SlipAlert-module--icon--03d35";
export var info = "SlipAlert-module--info--d2c3a";
export var message = "SlipAlert-module--message--6ee0c";
export var success = "SlipAlert-module--success--7ab0b";
export var topAligned = "SlipAlert-module--topAligned--4169e";
export var warning = "SlipAlert-module--warning--71b55";